<div *ngIf="metodo === stripe_1" class="container">
    <div class="row" style="border-radius: 0.5rem;">
        <div class="col-md-12 col-sm-12 col-xs-12 h-100" style="border-radius: 0.5rem;">
            <form [formGroup]="forma" (keydown.enter)="$event.preventDefault()" enctype="multipart/form-data">
                <div class="modal-content h-100 bg-body" style="border-radius: 0.5rem;">
                    <div class="modal-header p-3" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 0.5rem 0.5rem 0 0;">
                        <h3 class="modal-title" class=" text-left"><strong>Pagos: {{metodo | uppercase}} </strong> </h3>
                    </div>
                    <div class="modal-body p-4">
                        <div class="row ">
                          <div class="col-md-12 p-1">
                            <label for="cc-number" class="form-label">Numero de tarjeta</label>
                            <div id="card-2" class="form-control form-control-lg w-100"></div>
                            <div class="invalid-feedback">
                              Requiere numero de tarjeta de credito
                            </div>
                          </div>
                          <div class="col-md-6 p-1">
                            <label for="cc-cvv" class="form-label">Codigo de seguridad</label>
                            <div id="cvc-1" class="form-control form-control-lg w-100"></div>
                            <div class="invalid-feedback">
                              Requiere codigo de seguridad
                            </div>
                          </div>
                          <div class="col-md-6 p-1">
                            <label for="cc-expiration" class="form-label">Fecha de vencimiento</label>
                            <div  id="exp-1" class="form-control form-control-lg w-100"></div>
                            <div class="invalid-feedback">
                              Requiere fecha de vencimiento
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12 p-1">
                                <img src="/assets/img/paypay.png" style=" width:100%; object-fit: 100% 100%;">
                            </div>
                        </div>
                  </div>
                    <div class="modal-footer p-3">
                        <div class="form-group">
                            <button mat-raised-button color="warn" (click)="cerrarmodal()" style="margin-right: 5px;">Cancelar</button>

                            <button mat-raised-button [disabled]="forma.invalid" class="btn btn-primary " (click)="modalrespuesta()">Pagar $ {{monto}} <i class="mx-2 far fa-credit-card"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div *ngIf="metodo === paypal_1" class="container">
    <div class="row" style="border-radius: 0.5rem;">
        <div class="col-md-12 col-sm-12 col-xs-12 h-100" style="border-radius: 0.5rem;">
            <form [formGroup]="forma" (keydown.enter)="$event.preventDefault()" enctype="multipart/form-data">
                <div class="modal-content h-100 bg-body" style="border-radius: 0.5rem;">
                    <div class="modal-header p-3" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 0.5rem 0.5rem 0 0;">
                        <h3 class="modal-title" class=" text-left"><strong>Pagos: {{metodo | uppercase}} </strong> </h3>
                    </div>
                    <div class="modal-body p-4">
                      <div class="row">
                        <div class="col-md-12  p-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nombre y apellido</mat-label>
                                <input matInput style="font-size: 12px; color: black;" formControlName="des_usuario" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-md-12  p-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Correo</mat-label>
                                <input matInput style="font-size: 12px; color: black;" formControlName="des_correo" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 p-1">
                            <img src="/assets/img/power_paypal.png" style=" width:100%; object-fit: 100% 100%;">
                        </div>
                    </div>
                  </div>
                    <div class="modal-footer p-3">
                        <div class="form-group">
                            <button mat-raised-button color="warn" (click)="cerrarmodal()" style="margin-right: 5px;">Cancelar</button>

                            <button mat-raised-button [disabled]="forma.invalid" class="btn btn-primary " (click)="modalrespuesta()">Pagar $ {{monto}} <i class="mx-2 far fa-credit-card"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>